import { sessionInfo } from './sessionInfo.js';

/** @type {string[]} */
export const LANGS = ['es', 'en', 'fr', 'de', 'it', 'pt', 'nl', 'br', 'ar'];

/** @type {string[]} */
export const USER_LANGS = getUserLangs();

/** @type {object<key, value>[]} */
export const LANGUAGES = toKeyValueTranslated(LANGS);

/** @type {object<key, value>[]} */
export const USER_LANGUAGES = toKeyValueTranslated(USER_LANGS);

/**
 *
 * @returns {string[]} array de idiomas en minusculas
 */
function getUserLangs() {
  let sessionLangs = sessionInfo?.userSecurityWebOptions?.LANGUAGES;
  if (sessionLangs && typeof sessionLangs === 'string') {
    sessionLangs = sessionLangs.toLowerCase().split(',');
  }
  // por defecto se filtra el arabe para el usuario de momento hasta que el arabe no sea oficial
  // no lo filtramos si en las propiedades web está explícitamente
  return sessionLangs || LANGS.filter((lang) => lang !== 'ar');
}

/**
 * Devuelve el nombre del idioma traducido.
 * @param {string} lang codigo lang en 2 letras, ej 'es' o 'en'
 * @returns {string}
 */
export function getLanguageById(lang = '') {
  const key = `global.idiomas_${lang.toLowerCase()}`;
  return edicom.locale.translate(key, '');
}

/**
 * Devuelve una lista key, value de idiomas.
 * @param {string[]} langs ['es', 'en']
 * @returns {object<key, value>[]} ej. [{key: 'es', value: 'Español'}, {key: 'en', value: 'Ingles'}]
 */
function toKeyValueTranslated(langs) {
  return langs.map((key) => {
    const value = edicom.locale.translate(`global.idiomas_${key}`);
    return { key, value };
  });
}
